var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeniorSoftwareDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 14.6667L18.3333 19.2501L13.75 23.8334",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.834 20.1667H31.1673",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2493 3.66675H2.74935C1.73683 3.66675 0.916016 4.48756 0.916016 5.50008V38.5001C0.916016 39.5126 1.73683 40.3334 2.74935 40.3334H41.2493C42.2619 40.3334 43.0827 39.5126 43.0827 38.5001V5.50008C43.0827 4.48756 42.2619 3.66675 41.2493 3.66675Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5007 7.33325H5.50065C4.99439 7.33325 4.58398 7.74366 4.58398 8.24992V35.7499C4.58398 36.2562 4.99439 36.6666 5.50065 36.6666H38.5007C39.0069 36.6666 39.4173 36.2562 39.4173 35.7499V8.24992C39.4173 7.74366 39.0069 7.33325 38.5007 7.33325Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeniorSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/senior_software_development.7a6d2f1489896445ee7a6cdbf7df19a2.svg";
export { ForwardRef as ReactComponent };